// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { CalendarView } from './__types__/FullCalendar.ts';
import type { CALENDAR_CONTEXT } from './components/TeamCalendarContextProvider.tsx';

export const LazyTeamCalendars: LoadableType<{
	calendarContext?: CALENDAR_CONTEXT;
	subCalendarId?: string;
	macroLegendPosition?: 'bottom' | 'right' | 'none';
	macroSubCalendarId?: string;
	initialView?: CalendarView;
	hideWeekends?: boolean;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TeamCalendars" */ './TeamCalendars.tsx'))
			.TeamCalendar,
});

export { LazyHomepageCard } from './LazyHomepageCard.ts';
export { LazyTeamCalendarSiteSettingsPage } from './LazyTeamCalendarSiteSettingsPage.ts';

export { ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE } from './site-settings/teamCalendarSiteSettingsConstants.ts';
export { CALENDAR_CONTEXT } from './components/TeamCalendarContextProvider.tsx';
